import { render } from "./SubjectMaster.vue?vue&type=template&id=3c3895d8&scoped=true"
import script from "./SubjectMaster.vue?vue&type=script&lang=js"
export * from "./SubjectMaster.vue?vue&type=script&lang=js"

import "./SubjectMaster.vue?vue&type=style&index=0&id=3c3895d8&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3895d8"]])

export default __exports__